
/**************************************************************
  RICH TEXT CLASS
  - Description: App for string conversion to DOM
***************************************************************/
var RichTextApp = function(options) {

  this.DEFAULTS = {
    linkify: {
      enable: true,
      class: 'hu-link',
      class_big: 'hu-big',
    },
    code: {
      enable: true,
      class: 'hu-code',
    },
    html: {
      enable: false,
    },
    symbols: {
      '*': {
        class: 'hu-bold'
      },
      '_': {
        class: 'hu-italic'
      }
    }
  };

  this.extendDefaults = function(defaults, options) {
    for (var key in options) {
      if (options.hasOwnProperty(key) && defaults.hasOwnProperty(key)) {
        defaults[key] = options[key];
      }
    }
    return defaults;
  };

  this.options = this.extendDefaults(this.DEFAULTS, options);

  this.transform = function(node, input) {
    if (node instanceof Node === false) {
      throw new Error('[RichText]: 1st argument must be a Node');
      return;
    }
    if (typeof input !== 'string') {
      throw new Error('[RichText]: 2nd argument must be a String');
      return;
    }
    node.innerHTML = '';
    if (input == '')
      return;

    var self = this;

    var transformer = new RichTextApp.Transformer(input, this.options);
    // HTML Inyection: {html}<script>alert('Hehe')</script>{/html}
    if (this.options.html.enable)
      transformer.htmlInjection();
    // Code blocks: ```Code```
    if (this.options.code.enable)
      transformer.codify();
    // División por línea
    transformer.divideByLine();
    // Procesamiento de cada item
    transformer.domify();
    // Linkify if enabled
    if (this.options.linkify.enable === true)
      transformer.linkify();

    var sections = transformer.sections;
    // Final step: Append all items to selected HTML element
    for (var i = 0; i < sections.length; i++) {
      node.appendChild(sections[i]);
    }

    return sections;
  };

};


/**************************************************************
  TRANSFORMER CLASS
  - Description: Contains all information about target transform
***************************************************************/
RichTextApp.Transformer = function(str, options) {
  this.raw = str;
  this.sections = [str];
  this.utils = new RichTextApp.Utils(options);

  this.htmlInjection = function() {
    var self = this;
    var reg = new RegExp(/{html}([\s\S]*?){\/html}/g);
    this.sections = this.utils.splitStringFocus(this.sections, reg);
    this.sections = this.sections.map(function(it) {
      return self.utils.convertToHtml(it, reg);
    });
  };

  this.codify = function() {
    var self = this;
    var reg = new RegExp(/```([\s\S]*?)```/g);
    this.sections = this.utils.splitStringFocus(this.sections, reg);
    this.sections = this.sections.map(function(it) {
      return self.utils.convertToCode(it, reg);
    });
  };

  this.divideByLine = function() {
    this.sections = this.utils.splitStringFocus(this.sections, '\n');
  };

  this.domify = function() {
    var self = this;
    this.sections = this.sections.map(function(it,i) {
      return self.utils.domifyString(it);
    });
    this.sections = this.utils.levelUpArray(this.sections);
  };

  this.linkify = function() {
    var self = this;
    this.sections = this.sections.map(function(it,i) {
      return self.utils.linkifyNode(it);
    });
    this.sections = this.utils.levelUpArray(this.sections);
  };
};

/**************************************************************
  FORMAT NODE CLASS
  - Description: Basic Unit that contains symbols info
***************************************************************/
RichTextApp.FormatNode = function(params) {
  this.index = (params.index > -1) ? params.index : -1;
  this.symbols = params.symbols || [];

  this.hasSymbol = function(sym) {
    return this.symbols.indexOf(sym) > -1;
  };

  this.removeSymbol = function(sym) {
    this.symbols = this.symbols.filter(function(el, i) {
      return el != sym;
    });
  };
};

/**************************************************************
  UTILS CLASS
  - Description: Functions and utilities
***************************************************************/
RichTextApp.Utils = function(options) {

  this.symbols = options.symbols;
  this.symbolsArr = Object.keys(options.symbols);
  this.linkify = options.linkify;
  this.code = options.code;

  /**
   * When val='b' Converts ['abc'] into ['a', 'b', 'c']
   * @param  {Array} arr Array to be converted
   * @param  {String} val Split value
   * @return {Array}
   */
  this.splitStringFocus = function(arr, val) {
    var reg = (val instanceof RegExp) ? val : new RegExp(val, 'g');
    var _arr = arr.map(function(el, i) { // ['abc']
      if (typeof el == 'string')
        return el.replace(reg, '¡çÇ!$&¡çÇ!').split('¡çÇ!');
      else
        return el;
    });
    _arr = this.levelUpArray(_arr.slice(0));// ['a','b','c']
    return _arr;
  };

  /**
   * When array contains an array element, levelUp that array. Example:
   * [['a','b'], 'c'] => ['a', 'b', 'c']
   * @param  {Array} arr Input array
   * @return {Array}
   */
  this.levelUpArray = function(arr) {
    for (var i = 0; i < arr.length; i++) { // [['a','b','c']]
      if (arr[i] instanceof Array) {
        arr.splice.apply(arr, [i, 1].concat(arr[i]));
      } else if ((
          arr[i].textContent == '' && arr[i].tagName != 'BR' && arr[i].innerHTML == '') || 
          arr[i] == '') {
        arr.splice(i--, 1);
      }
    } // ['a','b','c']
    return arr;
  };

  /**
   * Converts strings to arrays of strings separated by format
   * @param  {String} str
   * @return {Array}
   */
  this.domifyString = function(str) {
    if (typeof str !== 'string') return str;
    if (str == '\n') return document.createElement('br');

    var formatNodes = this.getFormatNodes(str);
    formatNodes = this.cleanFormatNodes(formatNodes.slice(0));
    // Dividir cadena en secciones
    var sections = this.getNodeSections(str, formatNodes);
    // Transformar en span cada sección, según símbolo.
    var dirtyNodes = this.nodeProcessor(sections, formatNodes);
    return dirtyNodes;
  };

  /**
   * Get symbol nodes
   * @param  {String} str Processed string
   * @return {Array} Nodes
   */
  this.getFormatNodes = function(str) {
    var self = this;
    var openingChar = [ '', ' ', '\n', '\t', '(', '[', '{', '\'', '\"', '\`', '¡', '¿' ];
    var closingChar = [ /*'',*/ ' ', '\n', '\t', ')', ']', '}', '\'', '\"', '\`', '!', '?', ',', '.', ';', ':' ];
    // formatNodes guarda los nodos encontrados en la cadena
    var formatNodes = [], lastIndexWasSymbol = false;
    for (var i = 0; i < str.length; i++) {
      // Busco si existe alguna coincidencia del símbolo encontrado con nuestro diccionario de símbolos
      var discover = this.discoverSymbol(str.slice(i));
      if (discover.state == true) {
        // Comprobar si es un símbolo de cierre:
        var lastNode = formatNodes[formatNodes.length - 1];
        // - Comprobando si coincide con algún símbolo del último nodo
        var isClosingSymbol = (lastNode) ? (lastNode.symbols.indexOf( discover.symbol ) > -1) : false;
        if (isClosingSymbol == true) {
          // Si es símbolo de cierre, nuevo nodo con substracción
          // Pero sólo si es final de palabra, para evitar conversiones indeseadas de símbolos internos:
          // Es final de palabra si:
          // - El índice posterior es un espacio vacío o en blanco o caracter de cierre.
          // - Los caracteres futuros corresponden a símbolos únicamente.

          var nextChar = str.charAt(i + discover.symbol.length);
          var hasFutureSymbols = futureSymbols(
            str.slice(i + discover.symbol.length).split(
              self.composeRegExp(closingChar)
            )[0]
          );
          if (hasFutureSymbols || closingChar.indexOf(nextChar) > -1) {
            formatNodes.push(
              this.createSubstractorNode(discover.symbol, i, lastNode)
            );
          }
          function futureSymbols(sample) {
            if (!sample || sample == '') return true;
            var re = self.composeRegExp(self.symbolsArr, 'exclusive');
            return sample.match(re) != null;
          }
          lastIndexWasSymbol = true;
        } else {
          // Si no es de cierre, nuevo nodo con adición
          // Pero sólo si es comienzo de palabra, para evitar conversiones indeseadas de símbolos internos:
          // Es comienzo de palabra si:
          // - El índice anterior corresponde a un símbolo.
          // - El índice anterior es un espacio vacío o en blanco o caracter de apertura.

          var prevChar = str.charAt(i - 1);
          if (lastIndexWasSymbol || openingChar.indexOf(prevChar) > -1) {
            formatNodes.push(
              this.createAdderNode(discover.symbol, i, lastNode)
            );
            lastIndexWasSymbol = true;
          }
        }
      } else {
        lastIndexWasSymbol = false;
      }
      // Salta tantas posiciones como longitud de símbolo;
      i += (discover.symbol) ? (discover.symbol.length - 1) : 0;
    }

    // Definición de primer nodo, aunque no tenga símbolo
    if (!formatNodes[0] || formatNodes[0].index != 0) {
      formatNodes.unshift(
        new RichTextApp.FormatNode({ index: 0, symbols: [] })
      );
    }
    return formatNodes;
  };

  /**
   * Búsqueda de símbolos.
   * - Dada una cadena '*' y unos símbolos {'*':{}}
   * - La función devuelve {state:true, symbol:'*'}
   * @param  {String} str
   * @return {Object}  Ejemplo: {state:Boolean, symbol:String}
   */
  this.discoverSymbol = function(str) {
    // Voy descartando hasta que queda un resultado
    var matches = this.symbolsArr;
    var symbol;

    matches = matches.filter(function(el, i) {
      return el == str.slice(0, el.length);
    });
    // Selecciono la concordancia de mayor longitud
    symbol = matches.sort(function(a, b) {
      return b.length - a.length;
    })[0];

    return {
      state: symbol != undefined,
      symbol: symbol
    };
  };

  /*
   * - Cada nodo añade o quita un único símbolo.
   * - Un nodo substractor está formado por los símbolos anteriores menos el coincidente.
   * - Un nodo sumador está formado por los símbolos anteriores más el añadido.
   */
  this.createSubstractorNode = function(symbol, i, node) {
    return new RichTextApp.FormatNode({
      index: i,
      symbols: node.symbols.slice(0).filter(function(el, i) {
        return el != symbol;
      })
    })
  };

  this.createAdderNode = function(symbol, i, node) {
    return new RichTextApp.FormatNode({
      index: i,
      symbols: (node) ? (function() {
        var _node = node.symbols.slice(0);
        _node.push(symbol);
        return _node;
      })() : [symbol]
    });
  };

  /**
   * La limpieza de nodos se basa en los siguientes principios:
   * -
   */
  this.cleanFormatNodes = function(nodes) {
    var pointer = nodes.length - 1;
    if (!nodes[pointer])
      return nodes;
    if (nodes[pointer].symbols.length == 0)
      return nodes;

    var cleanNodes = nodes.slice(0);
    // Si el último nodo tiene símbolos, éstos no tienen terminación
    // Selección de símbolos del último nodo.
    var symbols = nodes[pointer].symbols;
    var done = symbols.map(function() { return false });

    while (pointer > -1) {
      for (var i = 0; i < symbols.length; i++) {
        // Elimina el/los símbolos afectados
        if (!cleanNodes[pointer].hasSymbol(symbols[i]))
          done[i] = true;
        if (!done[i])
          cleanNodes[pointer].removeSymbol(symbols[i]);
      }
      if (cleanNodes[pointer + 1]) {
        if (JSON.stringify(cleanNodes[pointer + 1].symbols) == JSON.stringify(cleanNodes[pointer].symbols)) {
          // Remove duplicated node
          cleanNodes.splice(pointer + 1, 1);
        }
      }
      pointer--;
    }
    return cleanNodes;
  };

  // Devuelve la cadena dividida en secciones
  // - Cada sección es la determinada por los índices de cada nodo
  /**
   * [description]
   * @param  {[type]} str   [description]
   * @param  {[type]} nodes [description]
   * @return {[type]}       [description]
   */
  this.getNodeSections = function(str, nodes) {
    var sections = [];
    for (var i = 0; i < nodes.length; i++) {
      var start = nodes[i].index;
      var end = (nodes[i + 1]) ? (nodes[i + 1].index) : (str.length);
      sections.push( str.slice(start, end) );
    }
    return sections;
  };

  /**
   *
   * @param  {Array} sections Ej: ['*hola']
   * @param  {Array} nodes Array of FormatNodes
   * @return {Array} ['<span>hola</span>', '']
   */
  this.nodeProcessor = function(sections, nodes) {
    var self = this;
    return sections.map(function(el, i) {
      var _symbols = (nodes[i - 1]) ? (nodes[i - 1].symbols) : false;
      return self.spanify(el, nodes[i].symbols, _symbols);
    });
  };

  /**
   * Conversión a nodo de texto si es un nodo sin formato.
   * Conversión a span si el nodo es cerrado.
   * Un nodo es cerrado si un símbolo del nodo actual coincide con un símbolo del nodo anterior.
   * @param  {String} str       Contenido del span
   * @param  {Array} symArray  ['*', '_']
   * @param  {Array} _symArray ['*']
   * @return {HTMLElement} or {Node}
   */
  this.spanify = function(str, symArray, _symArray) {
    var self = this;
    if (typeof str !== 'string') return str;
    // Eliminación de símbolos
    var pattern, re;
    // // Los símbolos del nodo anterior también deben ser borrados
    pattern = (_symArray) ? symArray.concat(_symArray) : symArray;
    re = this.composeRegExp(pattern, 'begins');
    str = str.replace(re, '');

    // Span classes
    var classes = symArray.map(function(el) {
      return self.symbols[el].class;
    });

    if (classes.length > 0) {
      var span = document.createElement('span');
      span.className = 'rich-text ' + classes.join(' ');
      span.textContent = str;
      return span;
    } else {
      return document.createTextNode(str);
    }
  };

  this.escapeRegExp = function(str) {
    if (!str)
      return '';
    var specials = ["-", "[", "]", "/", "{", "}", "(", ")", "*", "+", "?", ".", "\\", "^", "$", "|"];
    var regex = RegExp('[' + specials.join('\\') + ']', 'g');
    return str.replace(regex, "\\$&");
  };

  /**
   * Returns a RegExp based in an array with following structure:
   * / ^(arr[0]|arr[1]|...|arr[n])* /g
   * Taking into account special characters
   * @param  {Array} arr All array elements are included in RegExp
   * @param {String} type 'begins',
   * @return {RegExp}
   */
  this.composeRegExp = function(arr, type) {
    var self = this;
    if (type === 'begins')
      return new RegExp('^(' + arr.map(function(el) {
        return self.escapeRegExp(el);
      }).join('|') + ')+', 'g');
    else if (type === 'exclusive')
      return new RegExp('^(' + arr.map(function(el) {
        return self.escapeRegExp(el);
      }).join('|') + ')+$', 'g');
    else
      return new RegExp('(' + arr.map(function(el) {
        return self.escapeRegExp(el);
      }).join('|') + ')+', 'g');
  };

  /**
   * Converts strings with a certain pattern to an HTMLElement
   * @param  {String} str Input string
   * @return {HTMLElement} or {String}
   */
  this.convertToCode = function(str, reg) {
    if (typeof str !== 'string' || str === '') return str;

    var match = str.match(reg);
    if (match === null)
      return str;
    else {
      var span = document.createElement('span');
      span.className = 'rich-text ' + this.code.class;
      span.textContent = str.replace(reg, '$1');
      return span;
    }
  };

  /**
   * Converts strings with a certain pattern to an HTMLElement
   * @param  {String} str Input string
   * @return {HTMLElement} or {String}
   */
  this.convertToHtml = function(str, reg) {
    if (typeof str !== 'string' || str === '') return str;

    var match = str.match(reg);
    if (match === null)
      return str;
    else {
      var div = document.createElement('div');
      div.className = 'rich-text rich-text-noop';
      div.innerHTML = str.replace(reg, '$1').trim();
      return div;
    }
  };

  /**
   * Given a html element, detects links and transform into anchors.
   * @param  {Node} str Input HTMLElement
   * @return {Node} Processed node
   */
  this.linkifyNode = function(elem) {
    if (elem.className && elem.className.indexOf('rich-text-noop') > -1)
      return elem;

    var self = this;
    // Pattern:
    // - protocol: '(http(s)?(:\/\/))?(www\.)?',
    // - mail check: '([-\w\.]+@)?',
    // - domain: '(?:(?:[-\w\.]+',
    // - tld: '(\.(?:nl|se|no|es|milru|fr|es|uk|ca|de|jp|au|us|ch|it|io|org|com|net|int|edu|mil|arpa)))|',
    // - ipv4: '(?:(?:(?:[0-9]{1,3}\.){3}[0-9]{1,3})|(?:localhost)(?:[0-9]{1,5})?))',
    // - params: '([-a-zA-Z0-9:%_\+.~#?&//=@]*)' // Added '@'
    // - stylizers: '(?:(?:\[.+?\])*(?:!!)*)'
    var str = elem.textContent;
    var pattern = /(http(s)?(:\/\/))?(www\.)?([-\w\.]+@)?(?:(?:[-\w\.]+(\.(?:nl|se|no|es|milru|fr|es|uk|ca|de|jp|au|us|ch|it|io|org|com|net|int|edu|mil|arpa|ly|in)))|(?:(?:(?:[0-9]{1,3}\.){3}[0-9]{1,3})|(?:localhost)(?:[0-9]{1,5})?))([-a-zA-Z0-9:%_\+.~#?&//=@]*)(?:(?:\[.+?\])*(?:!!)*)/gi;

    var match, aux_str = str, sections = [];
    // ["enlace1.com y enlace2.com y enlace1.com"]
    while (match = pattern.exec(aux_str)) {
      var bef = document.createTextNode(aux_str.slice(0, match.index));
      var link = generateLink( aux_str.slice(match.index, match.index + match[0].length) );

      sections.push(bef, link);
      aux_str = aux_str.slice(match.index + match[0].length);
      // Reset index, as aux_str length has changed
      pattern.lastIndex = 0;
    }
    if (sections.length > 0 && aux_str != '') {
      sections.push(document.createTextNode(aux_str));
    }

    function generateLink(url) {
      var isTitle = url.slice(url.length - 2, url.length) == '!!';
      var hasContent = url.match(/\[.*\]/g) != null;
      var isHttp = url.slice(0, 4) == 'http';
      var isMail = (/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/).test(url);
      var anchor = document.createElement('a');

      // Classes
      var b = (isTitle) ? self.linkify.class + ' ' + self.linkify.class_big : self.linkify.class;

      // Content:
      // · http://www.helloumi.com[helloumi]!!
      var c = (isTitle) ? url.slice(0, url.length-2) : url;
      // · http://www.helloumi.com[helloumi]
      c = (hasContent) ? c.replace(/(^.*)\[(.*)\](.*)/g, '$2') : c;

      // Reference:
      // · www.helloumi.com[helloumi]!!
      var a = (isTitle) ? url.slice(0, url.length-2) : url;
      // · www.helloumi.com[helloumi]
      a = (hasContent) ? a.replace(/(^.*)\[(.*)\](.*)/g, "$1") : a;
      // · www.helloumi.com
      a = (isHttp || isMail) ? a : 'http://'.concat(a);
      // · http://www.helloumi.com
      a = (isMail) ? 'mailto:'.concat(a) : a;

      anchor.className = 'rich-text ' + b;
      anchor.href = a;
      anchor.target = (isMail) ? '_top' : '_blank';
      anchor.textContent = c;
      return anchor;
    }

    // Final step: Append all items to selected HTML element
    if (sections.length > 0) {
      elem.innerHTML = '';
      if (elem instanceof HTMLElement) {
        for (var i = 0; i < sections.length; i++) {
          if (sections[i].textContent != '')
            elem.appendChild(sections[i]);
        }
      } else return sections;
    }
    return [ elem ];
  };
};

RichTextApp.VERSION = '2.0.5';


// INSTANCE
const richText = new RichTextApp({
  linkify: {
    enable: true,
    class: 'hu-link',
    class_big: 'hu-size-big'
  },
  code: {
    enable: true,
    class: 'hu-code',
  },
  html: {
    enable: true,
  },
  symbols: {
    '*': { class: 'hu-w-bold' },
    '_': { class: 'hu-st-italic' },
    '%h1': { class: 'hu-s-20' },
    '%c1': { class: 'hu-color_accent' },
    '%c2': { class: 'hu-color_dark' },
  },
});
export default richText;


// WEBPACK FOOTER //
// ./app/js/components/plugins/RichTextApp.js